import Flex, { IFlexProps } from 'typescript-styled-flex'
import is from 'typescript-styled-is'
import styled, { ITheme } from '../../../theme'
import { INPUT_WIDTH } from '../elements/Input'

const Wrapper = styled(Flex as any)<IWrapperProps>`
  width: 100%;
  max-width: 100%;

  @media (min-width: ${(theme: ITheme) => theme.theme.breakpoints.tablet}) {
    max-width: ${INPUT_WIDTH}px;
    ${is('maxWidth')`
      max-width: ${({ maxWidth }: IWrapperProps) => maxWidth};
    `}
  }
`

export default Wrapper

export interface IWrapperProps extends IFlexProps {
  maxWidth?: string | number
}
